import React from "react";
import { useParams } from "react-router";
import { TaskProvider } from "../../../providers";
import { TaskContent } from "./task-content";

export const ViewTask: React.FC = () => {
  const { _id } = useParams<{ _id: string }>();

  if (!_id) {
    return <div>No task ID provided</div>;
  }

  return (
    <TaskProvider taskId={_id}>
      <TaskContent />
    </TaskProvider>
  );
};
